module.exports = __webpack_public_path__ + "0004ed231cb4ea2877f1048fec4df233.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/circle_simple_integration.png
// module id = 177
// module chunks = 0